import { EcommerceAPI } from "./Client";

const buildQuery = (params) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return query.toString();
};

export const getUserActivityAPI = (payload = {}) => {
  const query = buildQuery({
    page: payload?.page ?? 0,
    size: payload?.size ?? 10,
    sortBy: payload?.sortBy ?? "lastVisitAt",
    sortDir: payload?.sortDir ?? "desc",
    year: payload?.year ?? 0,
    month: payload?.month ?? 0,
    day: payload?.day ?? 0,
    startDate: payload?.startDate,
    endDate: payload?.endDate,
  });

  return EcommerceAPI.get(`/get/user-activity?${query}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getUserActivityStatesAPI = (payload = {}) => {
  const query = buildQuery({
    activityId: payload?.activityId,
    page: payload?.page ?? 0,
    size: payload?.size ?? 10,
    sortBy: payload?.sortBy ?? "createdAt",
    sortDir: payload?.sortDir ?? "desc",
  });

  return EcommerceAPI.get(`/get/user-activity/states?${query}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
